import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {an} from "@fullcalendar/core/internal-common";

@Injectable({
    providedIn: 'root',
})
export class ParameterService {
    private readonly PARAM_API: string;
    private readonly OPEN_API: string;

    constructor(private http: HttpClient) {
        this.PARAM_API = `${environment.apiUrl}/parameter/`;
        this.OPEN_API = `${environment.apiUrl}/open/`;
    }

    async getParameterByName(parameterName: string): Promise<any> {
        return await this.http.get(this.PARAM_API + `find-by-name/${parameterName}`).toPromise();
    }

    async getMaintenanceMode(): Promise<any> {
        return await this.http.get(this.OPEN_API + `maintenance-mode`).toPromise();
    }

    async getStripeTableData(): Promise<any> {
        return await this.http.post(this.PARAM_API + `stripe-table-credential`, {}).toPromise();
    }
}